import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ClientLayout from '../../../components/client/ClientLayout'
import BusinessLogo from "../../../components/client/BusinessLogo";
import Link from "next/link";
import moment from 'moment-timezone';
import { useRouter } from "next/router";
import { useClientAPI } from "../../../contexts/clientAPI";
import { CgSpinner } from "react-icons/cg";
import Emoji from "a11y-react-emoji";
import { RiArrowLeftSLine } from 'react-icons/ri'
import ClientLoginModal from "../../../components/client/ClientLoginModal";
import uniqolor from "uniqolor";
import _ from "lodash";
import Head from "next/head";
import { appointmentStatus, BUSINESS_APPROVAL_STATUS } from '../../../constants'
import { getCancellationText } from '../../../services/frontendServices/AppointmentService'
import { toast } from 'react-toastify'
import ErrorMessage from '../../../components/client/ErrorMessage'
moment.tz.setDefault("Asia/Jerusalem")

function Bookings({ businessDetails, pageCode, error }) {
    const router = useRouter()
    const { whoami, logoutUser } = useClientAPI();
    const [openLoginModal, setOpenLoginModal] = useState(false);
    const [loadingUser, setLoadingUser] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(async () => {
        await loadUser({ showErrorMessage: false })
    }, [])

    const handleLogout = async () => {
        setLoadingUser(true);
        const { pageCode } = router.query
        await logoutUser({ pageCode })
        setCurrentUser(null)
        setLoadingUser(false);
    }

    async function loadUser({ showErrorMessage = false }) {
        setLoadingUser(true)
        if (pageCode) {
            try {
                const data = await whoami({ pageCode })
                if (data?.user) {
                    setCurrentUser({ ...data.user, appointments: data.appointments })
                } else {
                    setCurrentUser(null)
                }
            } catch (err) {
                if (showErrorMessage) toast.error('אירעה שגיאה בהתחברות, נסו שנית מאוחר יותר או פנו לתמיכה')
                setCurrentUser(null)
            }
        }
        setLoadingUser(false)
    }

    if (error) {
        if (error === 'businessNotFound') {
            return (
                <div className="px-2">
                    <div
                        className='mx-auto my-36 max-w-2xl px-2 border rounded-md text-center p-5 py-10'>
                        <div className='text-xl font-bold'>עסק לא נמצא</div>
                        <Link href='/'>
                            <a className='text-blue-500'>חזור לדף הבית</a>
                        </Link>
                    </div>
                </div>
            )
        }

        return (
            <ErrorMessage title={'זמן טוב'}>
                <p className='mb-6'>נראה שמשהו השתבש... נסו להיכנס מחדש או פנו לתמיכה</p>
            </ErrorMessage>
        )
    }

    return (
        <>
            <div className="sm:px-2 mx-auto tracking-tight max-w-2xl mt-28 mb-10 sm:mt-36">
                <Head>
                    <title key='maintitle'>התורים שלי | {businessDetails.business.details.name} | זמן
                        טוב</title>
                    <meta name="viewport"
                        content="viewport-fit=cover,width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no" />
                    <meta name="description" key='description'
                        content={businessDetails.business.details.description ? businessDetails.business.details.description : `קבעו תור ל${businessDetails.business.details.name}, בדקו שעות פתיחה, וצרו קשר עם העסק`} />
                    <meta property="og:title" key='ogtitle'
                        content={`התורים שלי | ${businessDetails.business.details.name} | זמן טוב`} />
                    <meta property="og:description" key='ogdescription'
                        content={businessDetails.business.details.description ? businessDetails.business.details.description : `קבעו תור ל${businessDetails.business.details.name}, בדקו שעות פתיחה, וצרו קשר עם העסק`} />
                    <meta property="og:image" key='ogimage'
                        content={businessDetails.business.details.logo ? `https://zmantov.fra1.digitaloceanspaces.com/logos/${businessDetails.business.details.logo}` : 'https://zmantov.co.il/img/business/store-placeholder.png'} />
                    <meta property="og:url" key='ogurl'
                        content={`https://zmantov.co.il/b/${businessDetails.business.pageCode}/`} />
                </Head>
                <div className='px-2 border-b border-t rounded-0 sm:border sm:rounded-md sm:shadow-sm'>
                    <div>
                        <div className='absolute inset-x-0 top-7 sm:top-16'><BusinessLogo
                            url={businessDetails.business.details.logo} />
                        </div>
                    </div>
                    <div className='p-2 sm:p-5 pt-16 justify-center flex-col flex'>
                        {/*<Link href={`/b/${pageCode}`}>*/}
                        {/*    <a className="self-center flex text-white bg-green-400 justify-center hover:bg-green-600 font-medium rounded-lg text-base px-6 mx-2 py-3 sm:w-auto w-full text-center">*/}
                        {/*        <span>*/}
                        {/*            קביעת תור חדש*/}
                        {/*        </span>*/}
                        {/*    </a>*/}
                        {/*</Link>*/}
                    </div>
                    <div className="flex flex-col justify-center items-center pb-5 overflow-hidden">
                        {loadingUser ?
                            <div className='pt-10 md:pb-10 mx-auto my-auto'>
                                <CgSpinner className='mx-auto my-auto animate-spin text-blue-600' size={50} />
                            </div>
                            :
                            <>
                                {currentUser ?
                                    <>
                                        <div className="self-center w-full mt-2">
                                            <div className='text-center mb-5'>
                                                <div className='text-center text-xl font-medium sm:pt-12 pb-5 tracking-tight'>
                                                    <p>היי {currentUser.firstName}  <Emoji symbol="👋" label="waving hand" /></p>
                                                    <div className='text-center text-xs self-center font-normal mt-1 text-gray-500'>
                                                        <span className='pl-1'>(את/ה לא {currentUser.firstName}?</span>
                                                        <a className='underline cursor-pointer'
                                                            onClick={handleLogout}>לחצו
                                                            להתנתקות)</a>
                                                    </div>
                                                </div>
                                                <p className='text-gray-600 text-base'>
                                                    כאן ניתן לראות את 50 התורים האחרונים שלך אצל {businessDetails.business.details.name}.
                                                </p>
                                                <div className='mt-2'>
                                                    <Link
                                                        href={`/b/${businessDetails.business.pageCode}`}>
                                                        <a className='text-blue-700 bg-blue-50 hover:bg-blue-100 rounded py-1.5 px-2 text-sm'>
                                                            לחצו לקביעת תור נוסף
                                                        </a>
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className='w-full p-2 md:p-4 mt-7'>
                                                {currentUser.appointments.length === 0 &&
                                                    <div className='bg-gray-50 p-5 text-gray-500 text-center'>אין תורים להצגה</div>}
                                                {currentUser.appointments && currentUser.appointments.length > 0 &&
                                                    <ol className="relative border-r border-gray-200 dark:border-gray-700">
                                                        {currentUser.appointments.map((appointment) => <CustomerEvent business={businessDetails.business} appointment={appointment} key={appointment._id} />)}
                                                    </ol>
                                                }
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="md:w-1/2 self-center md:mr-2 mt-5 md:mt-0 mb-5">
                                            <div className='text-center mb-5'>
                                                <div className='text-center text-xl font-medium sm:pt-12 pb-5 tracking-tight'>
                                                    <p> היי <Emoji symbol="👋" label="waving hand" /></p>
                                                </div>
                                                <p className='text-gray-600 text-base'>
                                                    התחברו על מנת לראות את כל התורים שלכם אצל {businessDetails.business.details.name}
                                                </p>
                                            </div>
                                            <div className='text-center'>
                                                <div
                                                    className='flex flex-col justify-center items-center space-y-4'>
                                                    <button onClick={() => setOpenLoginModal(true)}
                                                        className="text-blue-700 bg-blue-50 hover:bg-blue-100 rounded py-3 px-2 w-48 font-medium">
                                                        <span>התחברות</span>
                                                    </button>
                                                    <div>
                                                        <Link
                                                            href={`/b/${businessDetails.business.pageCode}`}>
                                                            <a className='text-black border-b border-gray-400'>או,
                                                                קבעו תור חדש</a>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <ClientLoginModal open={openLoginModal} setOpen={setOpenLoginModal} loadUser={loadUser} />
                                    </>
                                }
                            </>
                        }
                        <hr className='block sm:hidden mt-6' />
                    </div>
                </div>
                <Link href='/'>
                    <a
                        className='pt-6 text-center text-gray-600 text-sm space-y-1 flex flex-col justify-center hover:opacity-50'>
                        <div className='relative'>
                            <img src='/img/logo.png' className='w-28 mx-auto opacity-75'
                                alt='logo' />
                        </div>
                        <div>רוצים כזה לעסק שלכם? לחצו כאן.</div>
                    </a>
                </Link>
            </div>
        </>
    )
}

const CustomerEvent = ({ appointment, business }) => {
    const { NOT_CONFIRMED, CONFIRMED, CANCELLED } = appointmentStatus
    const { DECLINED, PENDING } = BUSINESS_APPROVAL_STATUS

    function getStatusText() {
        let text = ''
        const isPending = appointment.businessApprovalStatus === PENDING

        if (moment().isBefore(appointment.date)) {
            if (isPending) text = 'ממתין לאישור'
            else text = 'מתוכנן'
        } else if (isPending) text = 'לא אושר'
        else text = 'הסתיים'

        return text
    }

    return (
        <li className="mb-10 mr-4 px-1">
            <Link href={`/c/${appointment.pageId}/`}>
                <a>
                    <div className="absolute w-3 h-3 bg-gray-200 rounded-full -right-1.5 border border-white dark:border-gray-900 dark:bg-gray-700" />
                    <div className="mb-2 text-sm font-normal leading-none text-gray-500 flex items-center space-x-2 space-x-reverse">
                        {appointment.status === CANCELLED && <div
                            className='px-2 rounded py-px text-xs justify-center items-center text-red-500 font-medium space-x-reverse bg-red-50'>
                            {appointment.businessApprovalStatus === DECLINED ? 'נדחה על ידי העסק' : 'בוטל'}
                        </div>}
                        {appointment.status === CONFIRMED && <div
                            className='px-2 rounded py-px rounded-br-sm text-xs justify-center items-center text-green-500 font-medium space-x-reverse bg-green-50'>
                            הגעה אושרה
                        </div>}
                        {appointment.status === NOT_CONFIRMED && <div
                            className={`px-2 rounded py-px rounded-br-sm text-xs justify-center items-center font-medium space-x-reverse ${(moment().isBefore(appointment.date)) ? 'bg-blue-100 text-blue-500' : ' bg-gray-100 text-gray-500'}`}>
                            {getStatusText()}
                        </div>}
                        <div className='text-sm tracking-tight text-gray-900'>{moment(appointment.date).format('יום dddd, DD/MM/YYYY בשעה HH:mm')}</div>
                    </div>
                    <div className={`${(moment().isAfter(appointment.date) || appointment.status === CANCELLED) && 'opacity-60'} hover:opacity-100 hover:shadow-md border shadow-sm p-2 md:p-3 rounded space-y-1 relative`}>
                        <div className="bg-gray-100 absolute left-1 top-1 rounded pr-1 py-0.5 text-xs text-black">
                            <span className="flex items-center">
                                לפרטי התור
                                <RiArrowLeftSLine size={16} />
                            </span>
                        </div>
                        <div className='text-xs font-normal text-gray-500'>
                            <span className="inline-block w-2 h-2 ml-1 rounded-full"
                                style={{ background: uniqolor(appointment.serviceProvider._id).color }} />
                            {appointment.serviceProvider.firstName}
                        </div>
                        <h3 className="text-base font-semibold text-gray-900 dark:text-white">{appointment.serviceDetails.name}</h3>
                        <div className="text-xs space-x-2 space-x-reverse font-normal text-gray-700 flex">
                            <div>התור נקבע בתאריך:</div>
                            <div>{moment(appointment.createdAt).format('DD/MM/YYYY בשעה HH:mm')}</div>
                        </div>
                        <div className="text-xs space-x-1 space-x-reverse font-normal text-gray-700 flex">
                            {
                                appointment.status === CANCELLED &&
                                <div>{getCancellationText(appointment, true)}</div>
                            }
                            {
                                appointment.status !== CANCELLED && (moment().isBefore(appointment.date) || appointment.sentReminder) &&
                                <>
                                    <div>תזכורת</div>
                                    <div>
                                        {appointment.sentReminder ?
                                            moment(appointment.sentReminder).format('נשלחה ב- DD/MM/YYYY בשעה HH:mm') :
                                            `תישלח כ-${business.timeSettings.limits.reminderTime} שעות לפני התור`}
                                    </div>
                                </>
                            }
                        </div>
                        {appointment.customerComment &&
                            <div className='italic text-xs bg-yellow-50 w-full px-2 p-1 text-yellow-600'>{appointment.customerComment}</div>}
                    </div>
                </a>
            </Link>
        </li>
    )
}

export async function getServerSideProps({ query }) {
    const { pageCode } = query
    try {
        const { data } = await axios.get(`${process.env.NEXT_PUBLIC_API_BASE}/api/front/${pageCode}/`)

        return {
            props: { businessDetails: data, pageCode }
        }
    } catch (err) {
        return {
            props: {
                error: 'serverError'
            }
        }
    }
}

Bookings.Layout = ClientLayout;
export default Bookings;